import React, { Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";
import Lottie from "lottie-react";
import Loading from "./lotties/loading.json";
import NotFoundPage from "./pages/NotFoundPage";
import Layout from "./pages/Layout";
import "./responsive.css";

const Home = React.lazy(() => import("./pages/Home"));

function App() {
  return (
    <div className="App">
      <Suspense
        fallback={
          <div
            style={{
              height: "100vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Lottie animationData={Loading} autoPlay={true} loop={true} />
          </div>
        }
      >
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </div>
  );
}

export default App;
